import { AutoDimensionType } from "building-types/autoDimensions/autoDimensionTypesEnum";
import type { GeneratedDimension } from "building-types/dimensions/dimensionTypes";
import type { AutoDimensionHandle } from "building-types/handles/docEntityHandleTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { viewOverridableHandle } from "building-types/selectors/selectorTools";
import type { ViewOverridableHandle } from "building-types/selectors/selectorTypes";
import type { Table } from "common/data/table";
import { docEntityHandleHash } from "doc/entity/core/handleHash";

export function generateHighlightHandlesFromDimensions(
  input: Table<GeneratedDimension[]>,
  hashToHandle: { [docEntityHandleHash: string]: AutoDimensionHandle },
) {
  for (const levelId in input) {
    getEntityHighlightHandles(hashToHandle, input[levelId].map((d) => d.docEntityHandle) as DocEntityHandle[]);
  }
}

export function getEntityHighlightHandles(
  hashToHandle: { [docEntityHandleHash: string]: ViewOverridableHandle },
  handles: DocEntityHandle[],
) {
  for (const handle of handles) {
    if (!handle) {
      continue;
    }

    getEntityHighlightHandleForViewOverrideables(hashToHandle, handle);
  }

  return hashToHandle;
}

function getEntityHighlightHandleForViewOverrideables(
  hashToHandle: { [docEntityHandleHash: string]: ViewOverridableHandle },
  runtimeHandle: DocEntityHandle,
) {
  if (!viewOverridableHandle(runtimeHandle)) {
    return;
  }

  switch (runtimeHandle.type) {
    case "AUTO_DIMENSION": {
      switch (runtimeHandle.provenance.type) {
        case AutoDimensionType.AUTO_DIMENSION_FOUNDATION_EXTERIOR_BY_ROOM_MULTIPLE: {
          /**
           * Auto Dimension by Room Multiple is a special case where we need to swap in a entity handle that is
           * recognized by selection and entity highlighting. It requires
           */
          for (const roomEdge of runtimeHandle.provenance.roomEdges) {
            const persistedHandle = {
              ...runtimeHandle,
              provenance: { ...runtimeHandle.provenance, roomEdges: [roomEdge] },
            };
            hashToHandle[docEntityHandleHash(persistedHandle)] = runtimeHandle;
          }
          return;
        }
        case AutoDimensionType.AUTO_DIMENSION_FOUNDATION_INTERIOR_BY_ROOM_MULTIPLE: {
          /**
           * Auto Dimension by Room Multiple is a special case where we need to swap in a entity handle that is
           * recognized by selection and entity highlighting. It requires
           */
          for (const roomEdge of runtimeHandle.provenance.roomEdges) {
            const persistedHandle = {
              ...runtimeHandle,
              provenance: { ...runtimeHandle.provenance, roomEdges: [roomEdge] },
            };
            hashToHandle[docEntityHandleHash(persistedHandle)] = runtimeHandle;
          }
          return;
        }
        case AutoDimensionType.AUTO_DIMENSION_FLOOR_PLAN_EXTERIOR_BY_ROOM_MULTIPLE: {
          /**
           * Auto Dimension by Room Multiple is a special case where we need to swap in a entity handle that is
           * recognized by selection and entity highlighting. It requires
           */
          for (const roomEdge of runtimeHandle.provenance.roomEdges) {
            const persistedHandle = {
              ...runtimeHandle,
              provenance: { ...runtimeHandle.provenance, roomEdges: [roomEdge] },
            };
            hashToHandle[docEntityHandleHash(persistedHandle)] = runtimeHandle;
          }
          return;
        }

        default:
      }
      break;
    }
  }

  /**
   * If we don't have a specific case for the handle, just add it to the hash. No indirection is needed.
   */
  hashToHandle[docEntityHandleHash(runtimeHandle)] = runtimeHandle;
  return;
}
